import React from 'react';
import { Typography } from 'pvs-design-system';
import { Box } from '@mui/material';

const AccessDeniedPage: React.FC = () => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 16,
      }}
    >
      <Typography variant="h1">Access Denied</Typography>
      <Typography variant="p-md">
        You do not have permission to view the Virtual Library.
      </Typography>
    </Box>
  );
};

export default AccessDeniedPage;
